import React from 'react';
import logo from '../../img/logo.svg';
import './Visuals.scss';

const BodyHeaderContent: React.FC<{ title: string }> = props => {
    return (
        <div className="bodyHeaderContentContainer">
            <div className="title">
                {props.title}
            </div>
            <div>
                <img src={logo} alt="logo" className="logo"/>
            </div>
        </div>
    );
};

export default BodyHeaderContent;
